import React from 'react';
import { Table } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Head from './Head';
import Body from './Body';

const BonusesTable = ({ isLoading, items, onEdit }) => (
  <>
    <Table className="settings-bonuses__table">
      <Head />
      <Body items={items} isLoading={isLoading} onEdit={onEdit} />
    </Table>
  </>
);

BonusesTable.propTypes = {
  isLoading: PropTypes.bool,
  items: PropTypes.array,
  onEdit: PropTypes.func,
};

export default BonusesTable;
